import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { USER_MGMT_CNST } from '../../constants/proj.cnst';

import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { UM_TABLE_CNST } from '../../constants/table.cnst';
import { CommonService } from '../../services/common.service';
import { DataService } from '../../services/data.service';
import { EnvService } from '../../services/env.service';
import { UtilsService } from '../../services/utils.service';
import { HttpService } from '../../services/http.service';
import { AppStateService } from '../../services/app-state.service';
import { isNullOrUndefined } from '../../modules/shared';
import { DeleteComponent } from '../../modules/shared/components/delete/delete.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss']
})
export class CustomerComponent implements OnInit, OnDestroy {

  subscriptions : Subscription[] = [];

  tableConfig: any = {}
  tableData: any = [];
  tableDataCopy : any = [];
  isEditPermission: boolean = false;

  customerNamesWithIds : any[] = [];
  searchResultResponse : any = {};
  selectedCustomers : string[] = [];
  isSearchResultLoading : boolean = false;

  dataTypes = UM_TABLE_CNST.CLICKABLE_DATA_TYPE;
  modalData: any = [];
  loading: boolean = true;

  constructor(
    private httpSrv: HttpService,
    private dataSrv: DataService,
    private utilSrv: UtilsService,
    private router: Router,
    private commonService: CommonService,
    private appStateSrv: AppStateService,
    private envService : EnvService,
    private datePipe: DatePipe,
    public dialog: MatDialog) { }

  ngOnInit() {
    let permissions = this.appStateSrv.getUserPermissions();
    if(permissions && permissions['User Management'] && permissions['User Management']['resources'] && permissions['User Management']['resources']['ROLE'] && permissions['User Management']['resources']['ROLE']['actions']){
      this.isEditPermission = permissions['User Management']['resources']['ROLE']['actions'].indexOf('EDIT') !==-1 ? true: false;
    }
    this.setTableConfig();
    this.setTableData();

    const operationRef = this.appStateSrv.operationRef.subscribe((value : any) => {
      let { operation, postData } = value;

      operation === USER_MGMT_CNST.OPERATION_TYPES.CUSTOMER.DELETE_CUSTOMER
        ? this.deleteCustomer(postData)
        : this.updateCustomer(postData);
    })

    this.subscriptions.push(operationRef);
  }

  addCustomerPage(){
    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;

    this.appStateSrv.setCustomerData({ operation: CUSTOMER_MODULE_OPERATIONS.ADD_CUSTOMER, info: null });

    this.router.navigate(['um', 'customer', 'addCustomer'], {
      queryParams: {
        operation: CUSTOMER_MODULE_OPERATIONS.ADD_CUSTOMER
      }
    });
  }

  // openAddCustomerModal() {
  //   const modalRef = this.modal.open(AddCustomerComponent,USER_MGMT_CNST.MODAL_OPTIONS);

  //   modalRef.result
  //   .then((result : any) => {
  //     let { operation, postData } = result;

  //     if (operation === USER_MGMT_CNST.OPERATION_TYPES.CUSTOMER.ADD_CUSTOMER) {
  //       this.addCustomer(postData);
  //     }
  //   })
  //   .catch((reason : any) => {
  //     console.log("Reason ", reason);
  //   })
  // }

  addCustomer(customerInfo: any) {
    let { name, purchasedPlan } = customerInfo;

    let postData = {
      meta : {
        customerName : name,
        purchasedPlan : purchasedPlan
      }
    };

    this.httpSrv
     .makePostApiCall('ADD_CUSTOMER', postData, this.envService.baseUrl)
     .subscribe((customerResponse : any) => {
       if(customerResponse.result){
        this.utilSrv.showToastMessage("Added customer successfully ","success");
        this.appStateSrv.setCurrentCustomerId(customerResponse.response);
       }
     }, err => {
       console.log("Error while adding customer ", err);
     })
  }

  updateCustomer(customerInfo: any) {

    let { customerId } = customerInfo;
    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;

    this.appStateSrv.setCustomerData({
      operation: CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER,
      info: customerInfo
    });

    if (!isNullOrUndefined(customerId)) {

      this.router.navigate(['um', 'customer', 'addCustomer'], {
        queryParams: {
          operation: CUSTOMER_MODULE_OPERATIONS.UPDATE_CUSTOMER,
          customerId
        }
      });
    }
  }

  deleteCustomer(customerInfo: any) {
    let { customerId } = customerInfo;

    let options = {
      'uriParams': { customerId }
    };

    this.httpSrv
      .makeDeleteApiCall('DELETE_CUSTOMER', this.envService.baseUrl, options)
      .subscribe((response: any) => {
        this.utilSrv.showToastMessage("Customer deleted successfully", "success");
        this.setTableData();
      }, err => {
        console.log("Error while deleting customer ", err);
        this.utilSrv.showToastMessage("Error while deleting customer", "error");
      })
  }

  setTableConfig() {
    this.tableConfig = this.commonService.setTableConfig(USER_MGMT_CNST.LIST_NAME_MAPPING.CUSTOMER_LIST);
  }

  setTableData() {
    this.loading = true;
    this.httpSrv.makeGetApiCall('GET_CUSTOMERS_LIST', this.envService.baseUrl).subscribe({
      next: (response: any) => {
        let customerList = this.formatTableData(response);
        this.tableData = this.dataSrv.addOptionsToTableData(customerList, UM_TABLE_CNST.RESOURCES_LIST.customers);
        this.tableDataCopy = [...this.tableData];
        this.customerNamesWithIds = this.dataSrv.formatCustomerNameSearchResponse(this.tableData);
        this.loading = false;
      },
      complete: () => {},
      error: () => {
        this.utilSrv.showToastMessage("Failed to fetch customers list", "error");
        this.loading = false;
      }
    });
  }

  setCutomerList(){
    this.customerNamesWithIds = [...this.dataSrv.formatCustomerNameSearchResponse(this.tableData)];
  }

  formatTableData(data: any){
     let customerKeys = Object.keys(data);
     let customerList = customerKeys.map(cust =>  {
       let customer = data[cust];
       customer['addedDate'] = this.datePipe.transform(new Date(customer['addedDate']), "dd MMM yyyy");
       return customer;
     })
     return customerList;
  }

  onCustomerNameEntered(event : any) {
    if (event.target.value.length >= 0 && this.selectedCustomers.length === 0) {
      this.loadSearchResultsByCustomerName(event.target.value);
    }
  }

  loadSearchResultsByCustomerName(searchQuery : string) {

    let options = {
      queryParams : {
        query : searchQuery
      }
    }

    this.isSearchResultLoading = true;

    this.httpSrv
      .makeGetApiCall('SEARCH_CUSTOMERS_BY_NAME', this.envService.baseUrl, options)
      .subscribe((searchResults : any) => {
        this.isSearchResultLoading = false;

        if (!isNullOrUndefined(searchResults.response)) {
          this.searchResultResponse = searchResults.response;
          this.searchResultResponse = this.formatTableData(searchResults.response);
          this.customerNamesWithIds = this.dataSrv.formatCustomerNameSearchResponse(searchResults.response);
        }
      }, (err: any) => {
        this.isSearchResultLoading = false;
        this.utilSrv.showToastMessage("Error in fetching search results", "error");
        console.log("Error in fetching search results ", err);
      })
  }

  onCustomerSelected() {

    //* If clear icon is clicked or backspace is pressed to clear the current selection
    //* then reset the already fetched items for the search query
    if (this.selectedCustomers.length === 0) {
      this.tableData = [...this.tableDataCopy];
      this.customerNamesWithIds = this.dataSrv.formatCustomerNameSearchResponse(this.tableData)
    }
    //* Filter table records according to the selected customer
    else {
      let filteredTableRecords: any = this.dataSrv
        .filterCustomerTableRecordsForCustomerName(this.searchResultResponse, this.selectedCustomers);

      filteredTableRecords = this.dataSrv.addOptionsToTableData(filteredTableRecords, UM_TABLE_CNST.RESOURCES_LIST.customers);
      this.tableData = filteredTableRecords;
    }
  }

  handleOptionClick(e: any) {
    console.log(e,888);
    
    let rowData = e.data;
    let { CUSTOMER_MODULE_OPERATIONS } = USER_MGMT_CNST;

    if (e.val == USER_MGMT_CNST.OPTIONS.VIEW) {
      let postData = this.tableData[e.key];

      let { customerId } = postData;

      if (!isNullOrUndefined(customerId)) {
        this.appStateSrv.setCustomerData({ operation: CUSTOMER_MODULE_OPERATIONS.VIEW_CUSTOMER, info: postData });

        this.router.navigate(['um', 'customer', 'addCustomer'], {
          queryParams: {
            operation: CUSTOMER_MODULE_OPERATIONS.VIEW_CUSTOMER,
            customerId
          }
        });

      } else {
        console.log("Customer id is null or undefined");
        this.utilSrv.showToastMessage("Customer id is missing", "error");
      }
    }

    else if (e.val == USER_MGMT_CNST.OPTIONS.DELETE) {
      const dialogRef = this.dialog.open(DeleteComponent, {
        disableClose: false,
        data: {},
      });

      let selectedCustomerRow = this.tableData[e.key];

      if (Object.keys(selectedCustomerRow).length > 0) {
        let { customerId } = selectedCustomerRow;

        let postData = { customerId }

        if ((customerId)) {
            dialogRef.afterClosed().subscribe(result => {
              if(result) {
                this.setOperationType({
                  operation: USER_MGMT_CNST.OPERATION_TYPES.CUSTOMER.DELETE_CUSTOMER,
                  postData
                })
              }
            });
        }
      }
    }

    else {
         let postData = this.tableData[e.key];
         this.setOperationType({operation: USER_MGMT_CNST.OPERATION_TYPES.CUSTOMER.EDIT_CUSTOMER,
        postData})
    }
  }

  setOperationType(value : any) {
    this.appStateSrv.operationRef.next(value);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription : Subscription) => subscription.unsubscribe());
  }
  assertUserData(item: any): { customerName: string } {
    return item as { customerName: string };
  }
  handleRowClick(item:any,indexOf:any){

  }

}
